export let NgMediaTranslationsEn = {
  download: 'Download file',
  file_name: 'File name:',
  file_type: 'File type:',
  uploaded_on: 'Uploaded on:',
  upload_image: 'Upload cropped image',
  description: 'Description:',
  update: 'Update',
  delete: 'Delete',
  drop_files: 'Drop files here to upload',
  drag_files_to_upload: 'Drag files here to upload',
  or: 'or',
  select_files: 'Select files...',
  allowed_file_types: 'You can only add %{types} files here.',
  delete_confirmation: 'Are you sure you want to delete this item?'
};

export function ngdTranslate(key: string, params: any = {}) {
  let field = NgMediaTranslationsEn[key] || key;
  const keys = Object.keys(params);
  for (const key2 of keys) {
    field = field.replace(`%{${key2}}`, params[key2]);
  }
  return field;
}

export function setTranslationKeys(keys) {
  NgMediaTranslationsEn = keys;
}

export function getTranslationKey(key) {
  return NgMediaTranslationsEn[key];
}
